import { IDiagnosticImage } from '../../../types/diagnostic-image'
import { useGet } from '../../query/useGet'

export function useGetSharedDiagnosticImages(diagnosticId: string) {
  const images = useGet<IDiagnosticImage[]>(
    `diagnostics/${diagnosticId}/diagnostic-images`
  )

  return images
}
